<template>
  <div class="page">
    <home-header activeIndex="1" pageTitle="单招报名确认" />
    <div class="wrapBig">
      <div class="Tabs">
        <div class="Title">单招报名确认</div>
        <div class="tabs">
          <template v-for="item in menuList">
            <!-- 淇℃伅濉姤 -->
            <div
              class="tab"
              v-if="item.tFlag == 'baseInfo' && item.enable == 1"
              :class="curTab == 4 ? 'active' : ''"
              @click="tabChange(item, 4)"
            >
              <div class="inner">
                <span>{{ item.tName }}</span>
                <span style="margin-left: auto;" v-if="item.status == 1"><img class="statusImg" src="@/assets/success.png" alt=""></span>
                <a-icon class="right" type="right" />
              </div>
            </div>
            <!-- 琛ㄥ崟涓嬭浇 -->
            <div
              class="tab"
              v-if="item.tFlag == 'fileXz' && item.enable == 1"
              :class="curTab == 1 ? 'active' : ''"
              @click="tabChange(item, 1)"
            >
              <div class="inner">
                <span>{{ item.tName }}</span>
                <span style="margin-left: auto;" v-if="item.status == 1"><img class="statusImg" src="@/assets/success.png" alt=""></span>
                <a-icon class="right" type="right" />
              </div>
            </div>
            <!-- 璇佹槑鏉愭枡涓婁紶 -->
            <div
              class="tab"
              v-if="item.tFlag == 'upload' && item.enable == 1"
              :class="curTab == 2 ? 'active' : ''"
              @click="tabChange(item, 2)"
            >
              <div class="inner">
                <span>{{ item.tName }}</span>
                <span style="margin-left: auto;" v-if="item.status == 1"><img class="statusImg" src="@/assets/success.png" alt=""></span>
                <a-icon class="right" type="right" />
              </div>
            </div>
            <!-- 鑾峰璧勬枡涓婁紶 -->
            <div
              class="tab"
              v-if="item.tFlag == 'lastUpload' && item.enable == 1"
              :class="curTab == 3 ? 'active' : ''"
              @click="tabChange(item, 3)"
            >
              <div class="inner">
                <span>{{ item.tName }}</span>
                <span style="margin-left: auto;" v-if="item.status == 1"><img class="statusImg" src="@/assets/success.png" alt=""></span>
                <a-icon class="right" type="right" />
              </div>
            </div>
            <div
              class="tab"
              v-if="item.tFlag == 'lastUpload' && item.enable == 1 && showArrivalIntentEntry"
              :class="curTab == 5 ? 'active' : ''"
              @click="toArrivalIntent"
            >
              <div class="inner">
                <span>报到意向确认</span>
                <a-icon class="right" type="right" />
              </div>
            </div>
          </template>
        </div>
      </div>
      <div class="tabContent">
        <div v-if="curTab == 4">
          <template v-if="item.id">
            <base-info
              ref="baseInfo"
              :modalName="item.tName"
              :type="item.id"
              :tFlag="item.tFlag"
              :desc="item.nExplain"
              :tjStatus="item.tjStatus"
              :tjTip="item.tjTip"
              @updateInfoType="updateInfoType"
            ></base-info>
          </template>
          <template v-else>
            <div class="example">
              <a-spin />
            </div>
          </template>
        </div>
        <div v-if="curTab == 1">
          <Download
            ref="fileXz"
            :modalName="item.tName"
            :type="item.id"
            :desc="item.nExplain"
            @updateInfoType="updateInfoType"
          />
        </div>
        <div v-if="curTab == 2">
          <Files
            ref="upload"
            :modalName="item.tName"
            :type="item.id"
            :tFlag="item.tFlag"
            :desc="item.nExplain"
            :tjStatus="item.tjStatus"
            :tjTip="item.tjTip"
            @updateInfoType="updateInfoType"
          />
        </div>
        <div v-if="curTab == 3">
          <Files2
            ref="lastUpload"
            :modalName="item.tName"
            :type="item.id"
            :tFlag="item.tFlag"
            :desc="item.nExplain"
            :tjStatus="item.tjStatus"
            :tjTip="item.tjTip"
            @updateInfoType="updateInfoType"
          />
        </div>
        <div v-if="curTab == 5 && showArrivalIntentEntry">
          <ArrivalIntent :embedded="true" />
        </div>
      </div>
    </div>
    <NextModal ref="nextModalRef" @next="nextStep" />
    <CompleteModal ref="completeModalRef" @next="nextComplete" />

    <Footer />
  </div>
</template>

<script>
import { getInfoType, getStatus, getStuStatus } from '@/api/form'
import { queryStatu } from '@/api/look'
import HomeHeader from '@/components/HomeHeader'
import Footer from '@/components/footer'
import BaseInfo from './components/baseInfo'
import Download from './components/download'
import Files from './components/files'
import Files2 from './components/files2'
import NextModal from './components/nextModal.vue'
import CompleteModal from './components/completeModal.vue'
import ArrivalIntent from './arrivalIntent.vue'

export default {
  name: 'singUp',
  components: {
    HomeHeader,
    Footer,
    BaseInfo,
    Download,
    Files,
    Files2,
    NextModal,
    CompleteModal,
    ArrivalIntent
  },
  data () {
    return {
      curTab: 4,
      menuList: [],
      item: {},
      name: '',
      type: '',
      desc: '',
      tjStatus: '',
      tjTip: '',
      flag: '',
      items: {},
      recruitStatus: '',
      arrivalIntentStatusLoaded: false,
      hasArrivalIntentAuth: false,
      showArrivalIntentEntry: false,
      currentMap: {
        baseInfo: 1,
        fileXz: 2,
        upload: 3,
        lastUpload: 4
      },
      cuntMap: {
        1: 'baseInfo',
        2: 'fileXz',
        3: 'upload',
        4: 'lastUpload'
      }
    }
  },
  methods: {
    updateArrivalIntentEntry () {
      this.showArrivalIntentEntry =
        this.hasArrivalIntentAuth && String(this.recruitStatus) === '6'
      if (
        this.arrivalIntentStatusLoaded &&
        !this.showArrivalIntentEntry &&
        String(this.curTab) === '5'
      ) {
        this.curTab = 4
      }
    },
    initArrivalIntentAuth () {
      const userInfo = JSON.parse(localStorage.getItem('user'))
      let hasAuth = false
      if (userInfo && userInfo.menuList) {
        userInfo.menuList.forEach((menu) => {
          if (menu.mcode === 'arrivalIntent') {
            hasAuth = true
          }
        })
      }
      this.hasArrivalIntentAuth = hasAuth
      this.updateArrivalIntentEntry()
    },
    queryRecruitStatus () {
      queryStatu({
        scode: localStorage.getItem('sCode')
      }).then((res) => {
        this.recruitStatus =
          res && res.data && res.data.recruit ? res.data.recruit.sStatus : ''
        this.arrivalIntentStatusLoaded = true
        this.updateArrivalIntentEntry()
      }).catch(() => {
        this.arrivalIntentStatusLoaded = true
        this.updateArrivalIntentEntry()
      })
    },
    toArrivalIntent () {
      this.curTab = 5
    },
    tabChange (item, val) {
      this.items = item

      if (val == 1) {
        this.getStatus(item, val)
        // if (this.flag >= 2) {
        //   this.curTab = val
        //   this.item = item
        //   localStorage.setItem('TypeId', item.id);
        // } else {
        //   this.$message.info('请先进行信息核对');
        // }
      }
      if (val == 2) {
        console.log(item, val, '120293')
        this.getStatus(item, val)
        // if (this.flag == 0 || this.flag == 1) {
        //   this.$message.info('请先进行信息核对');
        // } else {
        //   this.curTab = val
        //   this.item = item
        //   localStorage.setItem('TypeId', item.id);
        // }
      }
      if (val == 3) {
        this.curTab = val
        this.item = item
        localStorage.setItem('TypeId', item.id)
      }
      if (val == 4) {
        this.item = item
        this.curTab = val
        localStorage.setItem('TypeId', item.id)
      }
    },
    // 获取报名确认菜单
    getInfoType () {
      getInfoType().then((res) => {
        res.forEach(item => {
          item.status = 0
        })
        this.menuList = res

        if (this.curTab && this.menuList.length > 0) {
          this.menuList.forEach((element) => {
            if (this.curTab == 4 && element.tFlag == 'baseInfo') {
              this.item = element
              localStorage.setItem('TypeId', element.id)
            }
            if (this.curTab == 1 && element.tFlag == 'fileXz') {
              this.item = element
              localStorage.setItem('TypeId', element.id)
            }
            if (this.curTab == 2 && element.tFlag == 'upload') {
              this.item = element
              localStorage.setItem('TypeId', element.id)
            }
            if (this.curTab == 3 && element.tFlag == 'lastUpload') {
              this.item = element
              localStorage.setItem('TypeId', element.id)
            }
          })
        }

        this.updateInfoType(0)
      })
    },

    getStatus (item, val) {
      const userInfo = JSON.parse(localStorage.getItem('user'))
      let sid = ''
      if (userInfo) {
        sid = userInfo.sid
      }
      getStatus({
        sId: sid
      }).then((res) => {
        this.flag = res
        if (val == 1) {
          if (this.flag >= 2) {
            this.curTab = val
            this.item = item
            localStorage.setItem('TypeId', item.id)
          } else {
            this.$message.info('请先进行信息核对')
          }
        }
        if (val == 2) {
          if (this.flag == 0 || this.flag == 1) {
            this.$message.info('请先进行信息核对')
          } else {
            this.curTab = val
            this.item = item
            localStorage.setItem('TypeId', item.id)
          }
        }
      })
    },
    updateInfoType (jump) {
      const userInfo = JSON.parse(localStorage.getItem('user'))
      let sid = ''
      if (userInfo) {
        sid = userInfo.sid
      }
      getStuStatus({ sId: sid }).then(res => {
        console.log(1)

        this.menuList.forEach((item) => {
          res.forEach(list => {
            //  console.log(item.id , list.typeId);
            if (item.id == list.typeId) {
              item.status = 1
            }
          })
        })

        if (jump != 0) {
          const arr = []
          this.menuList.forEach(item => {
            if (item.status == 1) {
              arr.push(item)
            }
          })

          const tFlag = this.cuntMap[jump]

          if (arr.length == this.menuList.length) {
            this.$refs.completeModalRef.show()
          } else {
            this.$refs.nextModalRef.show(this.currentMap[tFlag])
          }
        }
      })
    },
    nextStep (type) {
      const tFlag = this.menuList[type].tFlag

      this.tabChange(this.menuList[type], this.currentMap[tFlag] - 1)
    },
    nextComplete () {
      this.$router.push({
        path: '/home'
      })
    }
  },
  mounted () {
    console.log('t', this.curTab)
    if (this.$route.query.curTab) {
      this.curTab = this.$route.query.curTab
    }
    this.getStatus()
    this.getInfoType()
    this.initArrivalIntentAuth()
    this.queryRecruitStatus()
  }
}
</script>

<style lang="less" scoped>
.page {
  background-color: #f5f5f5;
}
.wrapBig {
  width: 1200px;
  min-height: 448px;
  margin: 20px auto 24px;
  display: flex;
  justify-content: space-between;
}
.Tabs {
  width: 200px;
  .Title {
    width: 200px;
    height: 56px;
    line-height: 56px;
    background: #2a79ff;
    border-radius: 4px 4px 0 0;
    font-size: 18px;
    color: #ffffff;
    text-align: center;
  }
  .tabs {
    background: #fff;
    border-radius: 0 0 4px 4px;
  }
  .tab {
    line-height: 54px;
    color: #666;
    padding: 0 14px 0 16px;
    cursor: pointer;
    .inner {
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-bottom: 1px solid #eaeaea;

        .statusImg{
          width: 40px;
        }
    }
    .right {
      font-size: 12px;
      color: #999;
    }
    &:last-child {
      .inner {
        border: 0;
      }
    }
  }
  .active {
    background: #e5efff;
    color: #2a79ff;
    .right {
      color: #2a79ff;
    }
  }
}
.tabContent {
  width: 980px;
  min-height: 448px;
}
.card {
  background-color: #ffffff;
  border-radius: 6px;
}
.example {
  text-align: center;
  background: rgba(0, 0, 0, 0.05);
  border-radius: 4px;
  margin-bottom: 20px;
  padding: 30px 50px;
  margin: 20px 0;
}
</style>
